package songwritersnotebook.app.data

import kotlinx.serialization.Serializable
import songwritersnotebook.app.utils.ChordUtils
import com.benasher44.uuid.uuid4
import kotlinx.datetime.Clock

@Serializable
data class SavedChord(
    val id: String = uuid4().toString(),
    val ownerId: String = "",
    val chord: ChordDefinition,
    val dateAdded: Long = Clock.System.now().toEpochMilliseconds(),
    val isPublic: Boolean = false,
    val sharedWith: List<String> = emptyList(), // List of UIDs
    val tuning: List<String> = listOf("E2", "A2", "D3", "G3", "B3", "E4") // Capture tuning context
)
